import React from "react";
import {IonCheckbox} from '@ionic/react';


const WrapperIonCheckbox = (
    {
        checked = false,
        callback = () => {},
    }
) => {
    return <div className="i-checkbox" onClick={() => callback(!checked)}>
        <IonCheckbox mode="ios" className="i-checkbox-input" checked={checked}/>
        <div className={`i-checkbox-label ${checked ? 'active' : ''}`}></div>
    </div>
}


export default WrapperIonCheckbox;